import * as S from './ChooseCategories.styled';
import { ModalBase, ModalHeader, ChooseBase, ModalFooter, Buttons } from 'components';
import { Content } from './Content';
import { useFacade } from './useFacade';

const ChooseCategories = ({ title, allCategories, setAllCategories }) => {
  const {
    setIsOpen,
    isOpen,
    hadleCloseWindow,
    search,
    handleSearchOnChange,
    handleClearSearchValue,
    btnDeselectAll,
    handleDeselectAll,
    selectCategory,
    foundedCategories,
    saveButtonAction,
    isChanged,
  } = useFacade(allCategories, setAllCategories);

  return (
    <>
      <Buttons.SecondaryNormal
        id='categories'
        style={{ width: '100%' }}
        onClick={() => setIsOpen(true)}
      >
        Choose Categories
      </Buttons.SecondaryNormal>
      {isOpen && (
        <ModalBase>
          <S.Box>
            <ModalHeader title={title} close={hadleCloseWindow} />
            <S.Content>
              <ChooseBase.OneSection
                title='Search'
                searchValue={search}
                searchOnChange={handleSearchOnChange}
                handleClearSearchValue={handleClearSearchValue}
                showBtnDeselectAll={btnDeselectAll}
                handleDeselectAll={handleDeselectAll}
              >
                <Content
                  selectCategory={selectCategory}
                  foundedCategories={foundedCategories}
                  search={search}
                />
              </ChooseBase.OneSection>
            </S.Content>
            <ModalFooter
              saveButtonText='Apply'
              saveButtonOnClick={saveButtonAction}
              close={hadleCloseWindow}
              saveButtonDisabled={isChanged}
            />
          </S.Box>
        </ModalBase>
      )}
    </>
  );
};

export default ChooseCategories;
